(() => {
 const observers=new Map();
 const mount=(root=document)=>{
 root.querySelectorAll('[data-impact-logos]').forEach(strip=>{
  if(strip.closest('[data-impact-logo-proxy]'))return;
  const section=strip.closest('.shopify-section');
  if(!section)return;
  observers.get(section.id)?.disconnect();
  observers.delete(section.id);
  document.querySelectorAll('[data-impact-logo-proxy]').forEach(proxy=>{
   if(proxy.dataset.impactLogoProxy===section.id)proxy.remove();
  });
  strip.hidden=false;
  if(strip.dataset.attach!=='true')return;
  const previous=section.previousElementSibling;
  const sticky=previous?.querySelector('.lfp-impact-sticky');
  const impact=sticky?.closest('.lfp-impact');
  if(impact){
   // Shopify must retain its section wrappers in their original sibling order.
   // Only a presentation copy lives inside the parallax; never reparent a section.
   const proxy=document.createElement('div');
   proxy.className='lfp-logo-section';
   proxy.dataset.impactLogoProxy=section.id;
   const copy=strip.cloneNode(true);
   copy.removeAttribute('data-impact-logos');
   copy.querySelectorAll('[data-shopify-editor-block]').forEach(node=>node.removeAttribute('data-shopify-editor-block'));
   proxy.append(copy);
   impact.append(proxy);
   strip.hidden=true;
   const measure=()=>proxy.style.setProperty('--logo-strip-height',copy.getBoundingClientRect().height+'px');
   measure();
   const observer=new ResizeObserver(measure);
   observer.observe(copy);
   observers.set(section.id,observer);
  }
 });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(),{once:true});else mount();
 document.addEventListener('shopify:section:load',()=>mount());
 document.addEventListener('shopify:section:reorder',()=>mount());
 document.addEventListener('shopify:section:unload',event=>{
  observers.get(event.target.id)?.disconnect();
  observers.delete(event.target.id);
  document.querySelectorAll('[data-impact-logo-proxy]').forEach(proxy=>{
   if(proxy.dataset.impactLogoProxy===event.target.id)proxy.remove();
  });
 });
})();


